'use client'

import { useEffect, useState } from 'react'
import clsx from 'clsx'
import Arrow from '@/components/svg/icon/Arrow'

type Props = {
	children: React.ReactNode
	sectionRef: React.RefObject<HTMLDivElement>
	variant?: 'primary' | 'secondary' | 'tertiary'
	arrowAlign?: 'left' | 'right'
	className?: string
}

export default function ScrollDown({
	children,
	sectionRef,
	variant = 'primary',
	arrowAlign = 'right',
	className,
	...props
}: Props & React.ButtonHTMLAttributes<HTMLButtonElement>) {
	const [height, setHeight] = useState(0)

	useEffect(() => {
		if (sectionRef.current) {
			setHeight(sectionRef.current.offsetHeight - 48) // 48px = nav height
		}
	}, [sectionRef])

	return (
		<button
			type={props.type ?? 'button'}
			onClick={() => window.scrollTo({ top: height, behavior: 'smooth' })}
			className={clsx(
				'scroll-down-button flex cta cta-large group font-mono z-10',
				arrowAlign === 'left' ? 'flex-row-reverse' : '',
				{
					primary:
						'text-white bg-transparent [&_span]:text-blue [&_span]:bg-white hover:text-white-frosted',
					secondary:
						'text-white bg-transparent [&_span]:text-white [&_span]:bg-blue hover:text-white-frosted',
					tertiary:
						'text-blue-dark bg-transparent [&_span]:text-white [&_span]:bg-blue hover:text-contrast',
				}[variant],
				className
			)}
			{...props}
		>
			{children}
			<span className="arrow-container rotate-90">
				<Arrow
					className="absolute m-auto group-hover:animate-arrow"
					style={
						{
							'--from': '0, 0',
							'--to': '150%, 0',
						} as React.CSSProperties
					}
				/>
				<Arrow
					className="absolute m-auto group-hover:animate-arrow"
					style={
						{
							'--from': '-150%, 0',
							'--to': '0, 0',
						} as React.CSSProperties
					}
				/>
			</span>
		</button>
	)
}
